import { useAuthStore } from '../../store/useAuthStore';
export type BranchCacheEntry = {
  id: string;
  name: string;
  address: string | null;
  stock_sale_policy: 'block' | 'warn' | 'allow';
  barcode_input_mode: 'camera' | 'hardware' | 'both';
  scale_barcode_profile?: 'gs1_prefix' | 'ean13_255_price_pesos' | 'ean13_255_weight_grams';
  manual_discount_max_percent?: number;
  manual_discount_max_amount?: number;
  consolidate_cart_lines?: boolean;
  kitchen_fire_mode?: 'after_payment' | 'before_payment';
  cached_at: number;
  permissions_json?: string | null;
};

type BranchCacheOptions = {
  ttl?: number;
};

const BRANCHES_CACHE_TABLE = 'branches_cache';
const DEFAULT_TTL_MS = 24 * 60 * 60 * 1000;

function escapeSqlString(value: string): string {
  return value.replace(/'/g, "''");
}

function currentOwnerUserId(): string | null {
  return useAuthStore.getState().session?.user?.id ?? null;
}

function getTtl(options?: BranchCacheOptions): number {
  return options?.ttl ?? DEFAULT_TTL_MS;
}

async function cacheBranches(branches: BranchCacheEntry[]): Promise<void> {
    return;
}

async function getCachedBranches(options?: BranchCacheOptions): Promise<BranchCacheEntry[]> {
    const { getUserBranchesCacheIfFresh } = await import('./branchesMemoryCache');
        const memory = getUserBranchesCacheIfFresh();
        if (!memory?.length) return [];
        const cachedAt = Date.now();
        return memory.map((b) => ({
          id: b.id,
          name: b.name,
          address: null,
          stock_sale_policy: (b as { stockSalePolicy?: string }).stockSalePolicy === 'block' ? 'block' : (b as { stockSalePolicy?: string }).stockSalePolicy === 'allow' ? 'allow' : 'warn',
          barcode_input_mode: (b as { barcodeInputMode?: string }).barcodeInputMode === 'camera' ? 'camera' : (b as { barcodeInputMode?: string }).barcodeInputMode === 'hardware' ? 'hardware' : 'both',
          scale_barcode_profile:
            (b as { scaleBarcodeProfile?: string }).scaleBarcodeProfile === 'ean13_255_price_pesos'
              ? 'ean13_255_price_pesos'
              : (b as { scaleBarcodeProfile?: string }).scaleBarcodeProfile === 'ean13_255_weight_grams'
                ? 'ean13_255_weight_grams'
                : 'gs1_prefix',
          manual_discount_max_percent: (b as { manualDiscountMaxPercent?: number }).manualDiscountMaxPercent ?? 20,
          manual_discount_max_amount: (b as { manualDiscountMaxAmount?: number }).manualDiscountMaxAmount ?? 5000,
          consolidate_cart_lines: (b as { consolidateCartLines?: boolean }).consolidateCartLines !== false,
          kitchen_fire_mode:
            (b as { kitchenFireMode?: string }).kitchenFireMode === 'before_payment'
              ? 'before_payment'
              : 'after_payment',
          permissions_json: null,
          cached_at: cachedAt,
        }));
}

async function clearAllCache(): Promise<void> {
  // ADR-017 Fase 4: SQLite local eliminado — la caché vive en branchesMemoryCache (RAM).
}

async function clearExpiredCache(): Promise<void> {
  // ADR-017 Fase 4: SQLite local eliminado — la caché vive en branchesMemoryCache (RAM).
}

export { cacheBranches, getCachedBranches, clearAllCache, clearExpiredCache };
